module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-Logo.3b7d328f.webp";